import { Rule, RuleObject } from 'antd/lib/form';

export const requiredRule = (): Rule => ({
  required: true,
  message: `Поле обязательно для заполнения `,
});

export const minRule = (
  type: 'string' | 'number' | 'array',
  min: number,
  config?: RuleObject,
): Rule => ({
  ...config,
  type,
  min,
  message: config?.message || `Минимальное значение - "${min}"`,
});

export const maxRule = (
  type: 'string' | 'number' | 'array',
  max: number,
  config?: RuleObject,
): Rule => ({
  ...config,
  type,
  max,
  message: config?.message || `Максимальное значение - "${max}"`,
});
